export enum NativePage {
  IMPORT_USERS = 'IMPORT_USERS',
  EXAMS = 'EXAMS_NATIVE',
  ATTENDANCE_TRACKING_REPORT = 'ATTENDANCE_REPORT_NATIVE',
  PENDING_FEE_REPORT = 'PENDING_FEE_REPORT_NATIVE',
  CHEQUE_DETAIL_REPORT = 'CHEQUE_DETAIL_REPORT_NATIVE',
  IMPORT_CHEQUE_STATUS_REPORT = 'IMPORT_CHEQUE_STATUS_REPORT_NATIVE',
  IMPORT_TRANSACTION_STATUS_REPORT = 'IMPORT_TRANSACTION_STATUS_REPORT_NATIVE',
  CASH_FLOW_STATEMENT = 'CASH_FLOW_STATEMENT_NATIVE',
  CANCELLED_PAYMENTS_LOG = 'CANCELLED_PAYMENTS_LOG_NATIVE',
  CONSOLIDATED_MARKS_REPORT = 'CONSOLIDATED_MARKS_REPORT_NATIVE',
  SEARCH_STUDENT_FEE_ENTRY = 'SEARCH_STUDENT_FEE_ENTRY_NATIVE',
  OUTSTANDING_FEE_REPORT = 'OUTSTANDING_FEE_REPORT_NATIVE',
  ROLL_NO_UPDATE = 'ROLL_NO_UPDATE_NATIVE',
  FINAL_PROMOTION = 'FINAL_PROMOTION_NATIVE',
  SCHOOL_STAFF_SEARCH = 'SCHOOL_STAFF_SEARCH_NATIVE',
  STUDENT_PROFILE = 'STUDENT_PROFILE_NATIVE',
  PENDING_FEE_SUMMARY_REPORT = 'PENDING_FEE_SUMMARY_REPORT_NATIVE',
  DAILY_FEE_BOOK_PAGE = 'DAILY_FEE_BOOK_PAGE_NATIVE',
  PHOTO_ID_CARDS = 'PHOTO_ID_CARDS_NATIVE',
  PROVISIONAL_PROMOTION = 'PROVISIONAL_PROMOTION_NATIVE',
  ROLLOVER_STATUS = 'ROLLOVER_STATUS_NATIVE',
  FEE_STRUCTURE_PAGE = 'FEE_STRUCTURE_PAGE_NATIVE',
  LC_REPORT = 'LC_REPORT_NATIVE',
  DECLARATIONS = 'DECLARATION_SETUP_NATIVE',
  HASHTAGS_MANAGEMENT = 'HASHTAGS_MANAGEMENT_NATIVE',
  ACADEMIC_YEAR_WISE_TERMS = 'ACADEMIC_YEAR_WISE_TERMS_NATIVE',
  STUDENT_ELECTIVE_SUBJECTS_MAPPING = 'STUDENT_ELECTIVE_SUBJECTS_MAPPING_NATIVE',
  MARKS_ANALYTICS = 'MARKS_ANALYTICS_NATIVE',
  SUBJECTS_MANAGEMENT = 'SUBJECTS_MANAGEMENT_NATIVE',
  SCORING_TYPES = 'SCORING_TYPES_NATIVE',
  STUDENT_TRANSPORT_REPORT = 'STUDENT_TRANSPORT_REPORT_NATIVE',
  ROLLOVER_DASHBOARD = 'ROLLOVER_DASHBOARD_NATIVE',
  ROLLOVER_DASHBOARD_SCHOOL_AND_GRADEWISE = 'ROLLOVER_DASHBOARD_SCHOOL_AND_GRADEWISE_NATIVE',
  ASSESSMENTS_OVERVIEW = 'ASSESSMENTS_OVERVIEW_NATIVE',
  FULL_PAYMENT_CONCESSION = 'FULL_PAYMENT_CONCESSION_NATIVE',
  SCHOOL_CONFIGURATIONS = 'SCHOOL_CONFIGURATIONS_NATIVE',
  LIVE_TRIPS = 'LIVE_TRIPS_NATIVE',
  BUSES = 'BUS_MANAGEMENT_NATIVE',
  ROUTES_MANAGEMENT = 'ROUTES_MANAGEMENT_NATIVE'
}
